import { QueryClient } from "@tanstack/react-query";

/**
 * Singleton QueryClient shared across the entire app.
 *
 * Global defaults are conservative: staleTime / gcTime are kept short so data
 * stays fresh. Feature-level hooks (e.g. useEntityFiles) override these where
 * needed (e.g. 30 s staleTime + 60 s polling for CC-imported files).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60 * 1000, // 5 min — keep unmounted query data in memory briefly
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
